import { isAgent } from './isAgent'

/**
 *
 * @param {LCChatThread} thread
 * @returns {ChatConversation}
 */
export function getConversationFromChatThread(thread) {
  return thread.events
    .filter((e) => {
      return e.type === 'message'
    })
    .map((event) => {
      /** @type {ChatSessionMessage} */
      const message = {
        id: event.id,
        authorId: event.authorId,
        authorType: isAgent(event.authorId) ? 'agent' : 'user',
        text: event.text,
        timestamp: event.timestamp, // this is string... need to parse
      }
      return message
    })
}
